import { render, staticRenderFns } from "./TablePayments.vue?vue&type=template&id=4ec7e765"
import script from "./TablePayments.vue?vue&type=script&lang=js"
export * from "./TablePayments.vue?vue&type=script&lang=js"
import style0 from "./TablePayments.vue?vue&type=style&index=0&id=4ec7e765&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports